import { Link } from 'react-router-dom';
import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import Navbar from './Navbar';
import PageHeader from './PageHeader';
import SideBar from './SideBar';
import Footer from './Footer';
import usePageContext from '../hooks/usePageContext';
import { getFirstEntry } from '../helpers';
import { getUserData } from '../_actions';
import { ReactComponent as HomeIcon } from '../assets/images/home.svg';

const Page = ({ documentName, path, pageName, extraPath, children, customPath }) => {
  document.title = documentName;
  const user = getUserData();

  const { getNotifications, getItems, getConfig, firstRender } = usePageContext();

  useEffect(() => {
    getNotifications();
  }, [getNotifications]);

  useEffect(() => {
    if (firstRender) {
      getItems();
      getConfig();
    }
    // eslint-disable-next-line
  }, []);

  const renderCustomPath = () => {
    if (!customPath?.length)
      return (
        <>
          <Link to={getFirstEntry()} className="breadcrumb-item">
            <HomeIcon
              className="d-inline-block"
              style={{ marginRight: '8px', marginBottom: '4px' }}
            />
            Home
          </Link>
          {extraPath}
          <span className="breadcrumb-item active">{pageName}</span>
        </>
      );
    return (
      <>
        {customPath.map(({ link, name, Icon, extraClass }) => (
          <>
            {link ? (
              <Link to={link} className={`breadcrumb-item new ${extraClass}`}>
                <Icon />
                {name}
              </Link>
            ) : (
              <span className={`breadcrumb-item new ${extraClass}`}>{name}</span>
            )}
          </>
        ))}
      </>
    );
  };

  return (
    <>
      <Navbar />
      <PageHeader
        path={path}
        pageName={pageName}
        extraPath={extraPath}
        renderCustomPath={renderCustomPath}
      />
      <div className="page-content">
        <SideBar user={user} />
        <div className="content-wrapper pr-3">
          <div className="content p-0">{children}</div>
        </div>
      </div>
      <Footer />
    </>
  );
};

Page.propTypes = {
  documentName: PropTypes.string.isRequired,
  pageName: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  children: PropTypes.node,
  extraPath: PropTypes.node,
  customPath: PropTypes.instanceOf(Array)
};

Page.defaultProps = {
  extraPath: null,
  children: null,
  customPath: null
};

export default memo(Page);
